const POWERNIX_COMPANY_INFO = {
    logoImageUrl: "/assets/img/powernix_logo.png",
    subLogoImageUrl: "/assets/img/powernix_icon.png",
    navLogoImageUrl: "/assets/img/powernix_logo.png",
    stampImageUrl: "/assets/img/powernix_stamp.png",
    companyRegistrationNumber: "125 - 81 - 53601",
    companyName: "(주)파워닉스",
    representative: "윤광희",
    address: "세종특별자치시 한누리대로 207 세진이너스빌 3층 305호",
    businessType: "제조업",
    businessItem: "전기설비엔지니어링",
    representativePhone: "070-8633-4660",
    fax: "0505-300-6817",
};
const POWERNIX_CODE_INFO = {
    commercialPrefix: "PN-",
    researchPrefix: "PN(R)-",
    inhouseBidNumberPrefix: "PNPQ_",
    projectPrefix: "PN_",
    commercialPurchasePrefix: "AP-",
    researchPurchasePrefix: "AP(R)-",
};
/**
 * @description 제품 분류 정의
 * - 시트 헤더 생성 및 요약 시트 데이터 생성에 사용
 *
 * @Error 이름(name) 사용 불가 문자 - * ? : \\ / [ ]
 */
const PRODUCT_CLASSIFICATION_DEFINITIONS = [
    {
        name: "AHF,SVG 자재",
        simpleCode: "(PN-AF,SVG)",
        filterKey: "AHF/SVG-AHF,SVG", // 분류
    },
    {
        name: "SVC,TSC 자재",
        simpleCode: "(PN-TSC,PN-SSM)",
        filterKey: "SVC/TSC-TSC",
    },
    {
        name: "일반 자재",
        simpleCode: "(PN-PT)",
        filterKey: "일반-PT",
    },
];
const POWERNIX_EXCEL_EXPORT_OPTIONS = {
    productClassificationInfo: PRODUCT_CLASSIFICATION_DEFINITIONS.map((def) => ({
        name: `${def.name} ${def.simpleCode}`,
        filterKey: def.filterKey,
    })),
    summaryTitleOptions: {
        columnWidths: [6, 18, 12, 12, 18, 15],
        title: "파워닉스(주) 자재(재고 자산) 현황",
    },
    summaryRowsOptions: PRODUCT_CLASSIFICATION_DEFINITIONS.map((def, idx) => {
        const splitName = def.name.split(" ");
        return {
            no: idx + 1,
            division: splitName[0],
            code: splitName[1] || "",
        };
    }),
};
export const POWERNIX_ERP_INFO = {
    companyInfo: POWERNIX_COMPANY_INFO,
    codeInfo: POWERNIX_CODE_INFO,
    excelExportOptions: POWERNIX_EXCEL_EXPORT_OPTIONS,
};
